import { createContext } from 'react';
import { IItemForGetShortInfo, IItemForGetShortInfoWithStatus, IUpdateSubcategoryRestaurantProperties } from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'saveAsPatch'
	| 'assignDishes'
	| 'success'
	| 'error';

export interface IEditSubcategoryRestaurantPropertiesState {
	needRefetchRestPropsData: boolean;
	customerName: string;
	categoryName: string;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	IDSelectedRestaurant: Nullable<string>;
	subcategoryId: string;
	subcategoryName: string;
	dishes: IItemForGetShortInfo[];
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	availableForRepetition: boolean;
	isHidden: boolean;
	dataForSubmit: Nullable<IUpdateSubcategoryRestaurantProperties>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editSubcategoryRestaurantPropertiesInitialState: IEditSubcategoryRestaurantPropertiesState = {
	needRefetchRestPropsData: false,
	customerName: '',
	categoryName: '',
	fetchedRestaurants: [],
	IDSelectedRestaurant: null,
	subcategoryId: '',
	subcategoryName: '',
	dishes: [],
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	availableForRepetition: false,
	isHidden: false,
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditSubcategoryRestaurantPropertiesContext extends IEditSubcategoryRestaurantPropertiesState {
	refetchRestPropsData(value: boolean): void;
	setIDRestaurant(value: Nullable<string>): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	toggleAvailableForRepetition(): void;
	toggleIsHidden(): void;
	setDataForSubmit(data: IUpdateSubcategoryRestaurantProperties): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditSubcategoryRestaurantPropertiesContext = createContext<IEditSubcategoryRestaurantPropertiesContext>({
	refetchRestPropsData: () => undefined,
	setIDRestaurant: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	toggleAvailableForRepetition: () => undefined,
	toggleIsHidden: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editSubcategoryRestaurantPropertiesInitialState,
});
